module.exports = __webpack_public_path__ + "img/296-d55dc0.png";